import styled from 'styled-components';

export default styled.ul`
  list-style: none;
  margin: 0 -1rem;
  padding: 0;
  display: flex;
`;
